export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const currentUser = initialState?.currentUser;
  const hasPermission = (code: string) => Boolean(currentUser?.isSuperAdmin || currentUser?.permissions?.includes(code));
  return {
    canAdmin: hasPermission('system:rbac:manage'),
    canAudit: hasPermission('system:audit:list'),
    hasPermission,
  };
}
